import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('CONTACT_QA_UNAVAILABLE_ROLE')